// src/pages/ProductsPage/ProductsPage.jsx

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'; 
import Navbar from '../../components/Navbar/Navbar'; 
import Footer from '../../components/Footer/Footer'; 
import FilterSidebar from '../../components/FilterSidebar/FilterSidebar';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import HeroSection from '../../components/HeroSection/HeroSection';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { brands as staticBrands } from '../data/productData'; 
import './ProductsPage.css';
import { db } from '../firebase/firebase-config';

function ProductsPage() {
  const [allProducts, setAllProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- Filtre State'leri GÜNCELLENDİ ---
  const [selectedCategories, setSelectedCategories] = useState([]); 
  const [selectedSubCategories, setSelectedSubCategories] = useState([]); // <-- YENİ
  const [selectedBrands, setSelectedBrands] = useState([]); 
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });
  const [sortBy, setSortBy] = useState('newest'); 

  const [searchParams] = useSearchParams();

  // Verileri çek (useEffect GÜNCELLENDİ)
  useEffect(() => {
    const categoryParam = searchParams.get('kategori'); 

    const fetchData = async () => {
      setLoading(true);
      try {
        const categoriesQuery = query(collection(db, "categories"), orderBy("name", "asc"));
        const productsQuery = query(collection(db, "products")); 
        
        const [categorySnapshot, productSnapshot] = await Promise.all([
          getDocs(categoriesQuery),
          getDocs(productsQuery)
        ]);

        const categoryList = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const productList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        setCategories(categoryList);
        setAllProducts(productList);

        // URL'den parametre geldiyse (Footer'dan veya Navbar'dan)
        if (categoryParam) {
          // Gelen parametrenin hem ana hem de alt kategoride olup olmadığını kontrol et
          let isMainCat = categoryList.some(c => c.name === categoryParam);
          let isSubCat = categoryList.some(c => c.subCategories.some(s => s.name === categoryParam));

          if (isMainCat) {
            setSelectedCategories([categoryParam]);
          } else if (isSubCat) {
            setSelectedSubCategories([categoryParam]);
          }
        }
        
      } catch (error) {
        console.error("Firebase'den veri çekerken hata:", error);
      }
      setLoading(false);
    };
    fetchData();
  
  }, [searchParams]); // searchParams değişince filtreleri güncelleyebilmek için

  
  // --- Filtreleme Mantığı GÜNCELLENDİ ---
  const getFilteredAndSortedProducts = () => {
    let filtered = [...allProducts];

    // 1. Kategori/Alt Kategori Filtresi
    // Eğer HİÇBİR kategori filtresi yoksa, tüm ürünleri al
    if (selectedCategories.length > 0 || selectedSubCategories.length > 0) {
      // Bir Set kullanarak ürünlerin tekrar etmesini engelle
      const matchingProducts = new Set();
      
      // Önce ana kategori filtrelerini uygula
      if (selectedCategories.length > 0) {
        const mainCatProducts = allProducts.filter(p => 
          selectedCategories.includes(p.mainCategoryName)
        );
        mainCatProducts.forEach(p => matchingProducts.add(p));
      }
      
      // Sonra alt kategori filtrelerini uygula
      if (selectedSubCategories.length > 0) {
        const subCatProducts = allProducts.filter(p => 
          selectedSubCategories.includes(p.subCategoryName)
        );
        subCatProducts.forEach(p => matchingProducts.add(p));
      }
      
      filtered = [...matchingProducts]; // Set'i tekrar diziye çevir
    }
    
    // 2. Marka Filtresi (Kalan ürünler üzerinden)
    if (selectedBrands.length > 0) {
      filtered = filtered.filter(p => selectedBrands.includes(p.brandId));
    }

    // 3. Fiyat Filtresi (Kalan ürünler üzerinden)
    const minPrice = parseFloat(priceRange.min);
    const maxPrice = parseFloat(priceRange.max);
    if (!isNaN(minPrice) || !isNaN(maxPrice)) {
      filtered = filtered.filter(p => {
        const price = p.price;
        const passesMin = isNaN(minPrice) || price >= minPrice;
        const passesMax = isNaN(maxPrice) || price <= maxPrice;
        return passesMin && passesMax;
      });
    }

    // 4. Sıralama (En son)
    if (sortBy === 'price-asc') {
      filtered.sort((a, b) => a.price - b.price);
    } else if (sortBy === 'price-desc') {
      filtered.sort((a, b) => b.price - b.price);
    } else { // 'newest'
      filtered.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));
    }
    
    return filtered;
  };

  const filteredProducts = getFilteredAndSortedProducts();

  // --- Filtre Değişim Fonksiyonları GÜNCELLENDİ ---
  const handleCategoryChange = (categoryName) => {
    setSelectedCategories(prev =>
      prev.includes(categoryName)
        ? prev.filter(c => c !== categoryName)
        : [...prev, categoryName]
    );
  };
  
  // YENİ: Alt kategori değişim fonksiyonu
  const handleSubCategoryChange = (subCategoryName) => {
    setSelectedSubCategories(prev => 
      prev.includes(subCategoryName)
        ? prev.filter(s => s !== subCategoryName)
        : [...prev, subCategoryName]
    );
  };

  const handleBrandChange = (brandId) => {
    setSelectedBrands(prev =>
      prev.includes(brandId)
        ? prev.filter(b => b !== brandId)
        : [...prev, brandId]
    );
  };
  const handlePriceChange = (event) => {
    const { name, value } = event.target;
    if (/^\d*$/.test(value)) {
      setPriceRange(prev => ({ ...prev, [name]: value }));
    }
  };
  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };
  
  // GÜNCELLENDİ: clearFilters'a alt kategoriler eklendi
  const clearFilters = () => {
    setSelectedCategories([]);
    setSelectedSubCategories([]); // <-- YENİ
    setSelectedBrands([]);
    setPriceRange({ min: '', max: '' });
    setSortBy('newest');
  };

  return (
    <div className="products-page"> 
      <Navbar />
      <HeroSection
        pageType="small" 
        title="Ürün Gruplarımız"
        description="Aradığınız tüm ankastre, eviye, batarya ve aspiratör çözümleri burada."
        showButton={false}
      />

      <div className="products-page-container container"> 
        <FilterSidebar
          categories={categories}
          brands={staticBrands}
          selectedCategories={selectedCategories}
          selectedBrands={selectedBrands}
          priceRange={priceRange}
          sortBy={sortBy}
          onCategoryChange={handleCategoryChange}
          onBrandChange={handleBrandChange}
          onPriceChange={handlePriceChange}
          onSortChange={handleSortChange}
          onClearFilters={clearFilters}
          loading={loading}
          
          // --- YENİ PROPS ---
          selectedSubCategories={selectedSubCategories} 
          onSubCategoryChange={handleSubCategoryChange}
        />
        <main className="product-grid-area">
          <ProductGrid
            products={filteredProducts}
            loading={loading} 
          />
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default ProductsPage;